'use client';

import { cn } from 'common/utils';
import { useEffect, useState } from 'react';

type TabType = 'prime' | 'membership' | '';

const StickyTabs = () => {
  const [activeTab, setActiveTab] = useState<TabType>('');

  const handleTabClick = (tab: TabType) => {
    setActiveTab(tab);
    const sectionId = tab === 'prime' ? 'prime-section' : 'membership-section';
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Update active tab based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      const primeSection = document.getElementById('prime-section');
      const membershipSection = document.getElementById('membership-section');

      if (!primeSection || !membershipSection) return;

      const scrollPosition = window.scrollY + 150; // Offset for sticky header

      const primeTop = primeSection.offsetTop;
      const membershipTop = membershipSection.offsetTop;

      if (scrollPosition >= membershipTop) {
        setActiveTab('membership');
      } else if (scrollPosition >= primeTop) {
        setActiveTab('prime');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="sticky top-0 z-50 border-b border-pp-border-primary bg-white backdrop-blur-sm">
      <div className="mx-auto flex max-w-4xl justify-center gap-0 px-6 py-3">
        <button
          type="button"
          onClick={() => handleTabClick('prime')}
          className={cn(
            'border-1 w-1/2 rounded-l-xl border-solid px-6 py-4 text-xl font-black transition-all md:text-2xl',
            activeTab === 'prime'
              ? 'border-pp-text-tertiary bg-white text-pp-text-primary'
              : 'border-pp-border-primary bg-pp-bg-tertiary text-pp-text-primary hover:bg-pp-bg-secondary',
          )}
        >
          プライム登録
        </button>
        <button
          type="button"
          onClick={() => handleTabClick('membership')}
          className={cn(
            'border-1 w-1/2 rounded-r-xl border-solid px-6 py-4 text-xl font-black transition-all md:text-2xl',
            activeTab === 'membership'
              ? 'border-pp-text-tertiary bg-white text-pp-text-primary'
              : 'border-pp-border-primary bg-pp-bg-tertiary text-pp-text-primary hover:bg-pp-bg-secondary',
          )}
        >
          メンバーシップ
        </button>
      </div>
    </div>
  );
};

export default StickyTabs;
